import { SelectList } from "src/utilities/selectLists/selectList";

export class PackagingStatusHelper {
  /**
   * Estados del packaging
   */
  static readonly InUse = 10; // Envase en uso
  static readonly PendingPickup = 20; // Envase pendiente de recogida
  static readonly PickedUp = 30; // Envase recogido
  static readonly Transport = 40; // Envase en transporte
  static readonly DeliveredToPlant = 50; // Envase entregado en planta
  static readonly Received = 60; // Envase recibido

  /**
   * Obtiene la lista de estados para selectores con traducciones
   * @param translationService Servicio de traducción de angular-l10n
   * @returns Lista de estados traducidos
   */
  static GetStatusList(translationService: any): SelectList[] {
    const statusList: SelectList[] = [];
    [this.InUse, this.PendingPickup, this.PickedUp, this.Transport, this.DeliveredToPlant, this.Received].forEach((status) => {
      statusList.push({
        value: status.toString(),
        text: translationService.translate('$selectLists.packagingStatus' + status)
      });
    });
    return statusList;
  }

  /**
   * Obtiene la clave de traducción del estado
   * @param status Valor del estado
   * @returns Clave de traducción del estado
   */
  static GetStatusTranslationKey(status: number): string {
    switch (status) {
      case this.InUse:
        return "$selectLists.packagingStatus10";
      case this.PendingPickup:
        return "$selectLists.packagingStatus20";
      case this.PickedUp:
        return "$selectLists.packagingStatus30";
      case this.Transport:
        return "$selectLists.packagingStatus40";
      case this.DeliveredToPlant:
        return "$selectLists.packagingStatus50";
      case this.Received:
        return "$selectLists.packagingStatus60";
      default:
        return "";
    }
  }

  /**
   * Obtiene el texto traducido del estado
   * @param status Valor del estado
   * @param translationService Servicio de traducción de angular-l10n
   * @returns Texto traducido del estado
   */
  static GetStatusText(status: number, translationService: any): string {
    const key = this.GetStatusTranslationKey(status);
    return key ? translationService.translate(key) : '';
  }

  /**
   * Valida si un estado es válido
   */
  static IsValidStatus(status: number): boolean {
    return [
      this.InUse,
      this.PendingPickup,
      this.PickedUp,
      this.Transport,
      this.DeliveredToPlant,
      this.Received,
    ].includes(status);
  }

  /**
   * Devuelve la clase CSS para el estado del packaging
   * @param status Valor del estado
   * @returns Nombre de la clase CSS para el estado
   */
  static GetStatusColor(status: number): string {
    switch (status) {
      case this.InUse:
        return "in-use";
      case this.PendingPickup:
        return "pending";
      case this.PickedUp:
        return "picked-up";
      case this.Transport:
        return "in-transit";
      case this.DeliveredToPlant:
        return "delivered";
      case this.Received:
        return "received";
      default:
        return "unknown";
    }
  }
}
